import { COMPROBANTES } from "@/mocks/ecfMocks";
import { CheckCircle } from "lucide-react";

export default function ComprobantesTable() {
  return (
    <section id="comprobantes" className="bg-white py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-3 py-1 rounded-full border border-slate-200 text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
            Tipos e-CF
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            E31 a E47. Todos validados.
          </h2>
          <p className="text-slate-500 text-base max-w-md mx-auto">
            Soporte completo de todos los comprobantes fiscales electrónicos certificados por la DGII.
          </p>
        </div>

        {/* Table desktop */}
        <div className="hidden md:block overflow-hidden rounded-2xl border border-slate-100">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left text-xs font-semibold text-slate-500 uppercase tracking-widest px-6 py-4">Código</th>
                <th className="text-left text-xs font-semibold text-slate-500 uppercase tracking-widest px-6 py-4">Comprobante</th>
                <th className="text-left text-xs font-semibold text-slate-500 uppercase tracking-widest px-6 py-4">Estado</th>
                <th className="text-left text-xs font-semibold text-slate-500 uppercase tracking-widest px-6 py-4">Ambientes</th>
              </tr>
            </thead>
            <tbody>
              {COMPROBANTES.map((c, i) => (
                <tr
                  key={c.code}
                  className={`border-t border-slate-50 hover:bg-slate-50/50 transition-colors ${i % 2 === 0 ? "" : "bg-slate-50/30"}`}
                >
                  <td className="px-6 py-4">
                    <span className="font-mono text-sm font-bold text-blue-800 bg-blue-50 px-2.5 py-1 rounded-lg">
                      {c.code}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-sm font-medium text-slate-800">{c.name}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-100 px-3 py-1 rounded-full">
                      <CheckCircle size={12} />
                      {c.status}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex gap-1.5 flex-wrap">
                      {["TesteCF", "CerteCF", "eCF"].map((env) => (
                        <span key={env} className="text-xs text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full">
                          {env}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-3">
          {COMPROBANTES.map((c) => (
            <div key={c.code} className="bg-slate-50 rounded-xl p-4 border border-slate-100">
              <div className="flex items-center justify-between mb-2">
                <span className="font-mono text-sm font-bold text-blue-800 bg-blue-50 px-2.5 py-1 rounded-lg">
                  {c.code}
                </span>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700">
                  <CheckCircle size={11} />
                  Validado
                </span>
              </div>
              <p className="text-sm font-medium text-slate-800">{c.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}